import React from 'react';
import BaseSimpleItemBrowserHeader from "../BaseSimplePage/BaseSimpleItemBrowserHeader";
import ItemBrowserHeaderSimpleSelect from "../../components/ItemBrowserHeaderSimpleSelect";
import {allAuthorTagKinds} from "../../data/Enums";

const TagsItemBrowserHeader = ({
                                   authorTagKind,
                                   setAuthorTagKind,
                                   ...restProps
                               }) => {


    function renderExtraContent() {
        return (
            <div style={{marginTop: "10px", display: "flex", flexDirection: "column", gap: "10px"}}>
                <ItemBrowserHeaderSimpleSelect
                    label="Категория (для деятелей)"
                    options={authorTagKindOptions}
                    value={authorTagKind}
                    setValue={setAuthorTagKind}
                />
            </div>
        );
    }

    return (
        <BaseSimpleItemBrowserHeader
            {...restProps}
            renderExtraContent={renderExtraContent}
        />
    );
};

const authorTagKindOptions = [{id: 0, name: "(все)"}, ...allAuthorTagKinds];

export default TagsItemBrowserHeader;